import Swiper from 'swiper'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'

const toggleGrid = swiper => {
  if (swiper.enabled) {
    swiper.el.closest('.slider')?.classList.remove('disabled')
    if (swiper.wrapperEl.classList.contains('grid')) swiper.wrapperEl.classList.add('grid-disabled')
  } else {
    swiper.el.swiper.el.closest('.slider')?.classList.add('disabled')
    if (swiper.wrapperEl.classList.contains('grid')) swiper.wrapperEl.classList.remove('grid-disabled')
  }
}

const toggleClass = swiper => {
  if (swiper.enabled && swiper.params?.navigation?.enabled) {
    if (swiper.params?.slidesPerView === 1) {
      swiper.el.closest('.slider')?.classList.remove('slider_multiple')
    } else {
      swiper.el.closest('.slider')?.classList.add('slider_multiple')
    }
  }
}

const PAGINATION_EL = '.slider__pagination'
const NAVIGATION_EL = '.slider__control'

const BASE = {
  modules: [A11y, Navigation, Pagination, Autoplay],
  simulateTouch: false,
  slidesPerView: 1,
  spaceBetween: 20,
  loop: false,
  pagination: {
    el: PAGINATION_EL
  },
  navigation: {
    prevEl: NAVIGATION_EL + '_prev',
    nextEl: NAVIGATION_EL + '_next',
    enabled: false
  },
  breakpoints: {},
  on: {
    init: (swiper) => {
      toggleGrid(swiper)
      toggleClass(swiper)
    },
    resize: (swiper) => {
      toggleGrid(swiper)
      toggleClass(swiper)
    }
  }
}

function merge(target, ...sources) {
  if (!sources.length) return target

  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (
        isObject(source[key]) &&
        !Array.isArray(source[key])
      ) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        merge(target[key], source[key])
      } else if (Array.isArray(source[key])) {
        target[key] = [...source[key]]
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return merge(target, ...sources)
}

function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

function buildConfig(root) {
  let config = merge({}, BASE)

  Object.entries(root.dataset).forEach(([key, rawValue]) => {
    if (!key.startsWith('slider')) return

    const rest = key.slice('slider'.length)
    if (!rest) return

    const propName = rest.charAt(0).toLowerCase() + rest.slice(1)
    const trimmed = String(rawValue).trim()

    let value = trimmed

    // JSON (object/array)
    if (
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']'))
    ) {
      const parsed = parseJSON(trimmed)
      if (parsed !== null) {
        value = parsed
      }
    } else if (trimmed === 'true') {
      value = true
    } else if (trimmed === 'false') {
      value = false
    } else if (!Number.isNaN(Number(trimmed))) {
      value = Number(trimmed)
    }

    // если value — объект, то нужно глубокое объединение, а не перезапись
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      config[propName] = merge({}, config[propName] || {}, value)
    } else {
      config[propName] = value
    }
  })

  return config
}

function parseJSON(str) {
  try {
    return JSON.parse(str)
  } catch (e) {
    console.error('Failed to parse JSON:', str, e)
    return null
  }
}

function initSliders(ctx = document) {
  // Expected structure:
  // <div class="slider ... (optional)" data-slides-per-view="..." data-space-between="..." data-breakpoints='{}'>
  //   <div class="swiper">...</div>
  // </div>
  const roots = ctx.querySelectorAll('.slider')

  roots.forEach(root => {
    if (root._swiper) return
    const swiperEl = root.querySelector('.swiper')
    if (!swiperEl) return

    const config = buildConfig(root)

    root._swiper = new Swiper(swiperEl, config)
    root.dispatchEvent(new CustomEvent('swiper:init', {
      detail: {
        instance: root._swiper
      }
    }))
  })
}

function destroySliders(ctx = document) {
  ctx.querySelectorAll('.sliders').forEach(root => {
    if (root._swiper) {
      root._swiper.destroy(true, true)
      root.dispatchEvent(new CustomEvent('swiper:destroyed'))
      root._swiper = null
    }
  })
}

document.addEventListener('DOMContentLoaded', () => initSliders())
window.addEventListener('sliders:update', (e) => initSliders(e?.detail?.root || document))
window.addEventListener('sliders:destroy', (e) => destroySliders(e?.detail?.root || document))